import React from 'react';
import PropTypes from 'prop-types';

const Heading = ({ children, size, centered, className, dark }) => {
  return (
    <h1
      id="1"
      className={`title has-text-weight-bold ${size}   ${
        dark ? 'has-text-grey-dark' : 'has-text-white'
      }  ${centered && 'has-text-centered'}
      ${className}`}
    >
      {children}
    </h1>
  );
};

Heading.propTypes = {
  children: PropTypes.string.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf(['is-1', 'is-2', 'is-3', 'is-4', 'is-5', 'is-6']),
};

Heading.defaultProps = {
  className: '',
  size: 'is-1',
};

export default Heading;
